import moment from "moment-timezone";

var utilitiesMixin = {
  methods: {
    // time 1000
    // return 10:00
    getTimeFromInteger(time) {
      if (!time || time == 0) return null;
      var min = time.toString().slice(-2);
      var hour = time.toString().substring(0, time.toString().length - 2);
      if (min && hour)
        return moment({
          hour: hour,
          minute: min,
        }).format("HH:mm");
      return null;
    },
    // da formato HH:mm a formato numero in minuti
    converteStringaOreMinuti(t) {
      if (!t) return Number(0);
      // ritorna minuti
      var timeParts = t.split(":");
      if (timeParts.length > 0) {
        return Number(timeParts[0]) * 60 + Number(timeParts[1]);
      } else {
        return t;
      }
    },
    // da formato numero in minuti a formato hours + "h " + mins + "min"
    converteMinutiInStringaOreMinuti(totale) {
      let d = moment.duration(totale, "m");
      let hours = Math.floor(d.asHours());
      let mins = Math.floor(d.asMinutes()) - hours * 60;
      return hours + "h " + mins + "min";
    },
    // da formato numero in minuti a formato HH:mm
    converteMinutiInStringaOreMinutiFormatoHHmm(totale) {
      let d = moment.duration(totale, "m");
      let hours = Math.floor(d.asHours());
      let mins = Math.floor(d.asMinutes()) - hours * 60;
      return hours + ":" + mins;
    },
    // data YYYY-MM-DD
    // return DD/MM/YYYY
    parseDate2Gui(date) {
      if (!date || date == "0") return null;
      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    // data DD/MM/AAAA
    // return AAAA-MM-GG
    parseDateGui2AnnoMeseGiornoTrattino(date) {
      if (!date || date == "0") return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    // data DD/MM/YYYY
    // return YYYYMMDD
    parseDate2DBFromGiornoMeseAnnoBarra(date) {
      if (!date || date == "0") return null;
      const [day, month, year] = date.split("/");
      return `${year}${month.padStart(2, "0")}${day.padStart(2, "0")}`;
    },
    // data YYYY-MM-DD
    // return YYYYMMDD
    parseDate2DBFromAnnoMeseGiornoTrattino(date) {
      if (!date || date == "0") return null;
      const [year, month, day] = date.split("-");
      return `${year}${month.padStart(2, "0")}${day.padStart(2, "0")}`;
    },
    // data YYYYMMDD
    // return YYYY-MM-DD
    parseDateDBAnnoMeseGiornoTrattino(date) {
      if (!date || date == "0") return null;
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      const day = date.substring(6, 8);
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    // data YYYYMMDD
    // return DD/MM/YYYY
    parseDateDBGiornoMeseAnnoBarra(date) {
      if (!date || date == "0") return null;
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      const day = date.substring(6, 8);
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    // return data corrente formato YYYY-MM-DD
    dataCorrente() {
      return moment(new Date()).format("YYYY-MM-DD");
    },
    // return data corrente formato YYYYMMDD
    dataCorrenteDB() {
      var data = this.dataCorrente();
      const [year, month, day] = data.split("-");
      return `${year}${month.padStart(2, "0")}${day.padStart(2, "0")}`;
    },
    // return data formato YYYY-MM-DD da timestamp passato come parametro
    dataDaTimestamp(timestamp) {
      if (!timestamp) return null;
      return moment(new Date(timestamp)).format("YYYY-MM-DD");
    },
    // formato data YYYYMMDD
    // return mese
    getMeseDaDataDB(date) {
      if (!date || date == "0") return null;
      const month = date.substring(4, 6);
      return parseInt(month);
    },
  },
};

export default utilitiesMixin;
